module.exports = __webpack_public_path__ + "static/media/unwanted-car-buyers-home.6650966e.png";